import { createClient } from '@/lib/microcms/client';
import { Author } from '@/lib/microcms/client/types/model';
import {
  Banner,
  Blog,
  Campaign,
  DmmLiveOption,
  EntryCampaign,
  GradeRace,
  News,
  PaygentMaintenance,
  Term,
  TransferMaintenance,
  VelodromeInfo,
} from '@/lib/microcms/model';

type EndpointTypeMap = {
  news: News;
  campaign: Campaign;
  blog: Blog;
  bannerdata: {
    main: Banner[];
    top: Banner[];
    middle: Banner[];
    bottom: Banner[];
  };
  author: Author;
  velodrome: VelodromeInfo;
  dmmlive: DmmLiveOption;
  glossary: Term;
  entry_campaign: EntryCampaign;
  graderace: GradeRace;
  paygent_maintenance: PaygentMaintenance;
  transfer_maintenance: TransferMaintenance;
};

export const client = createClient<EndpointTypeMap>({
  serviceId: import.meta.env.VITE_MICROCMS_SERVICE_ID,
  apiKey: import.meta.env.VITE_MICROCMS_API_KEY,
});
